import Form from 'react-bootstrap/Form';
import Cookies from 'js-cookie';
import Button from 'react-bootstrap/Button';

import { useNavigate, Link, useLocation } from 'react-router-dom';
import React, { useContext, useState } from 'react';
import MessageModal from '../../utils/MessageModal';
import passwordValidator from 'password-validator';
import validator from 'validator';
import { useAuth } from 'react-oidc-context';

import SpeciaLogoWithName from '../../resources/SpeciaLogoWithName.png';

import SpeciaLogo2 from '../../resources/circle specia 2.png';

import jwt from 'jwt-decode';
import LoadingModal from '../../utils/LoadingModal';

import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import { Backdrop, CircularProgress } from '@mui/material';
import { SnackbarContext } from '../../App';

// import { Component }  from 'react';

export default function Registration() {
  // function signInWithAzure(){
  //     window.location.href = '/api/v1/auth/login';
  // }

  const search = useLocation().search;

  const queryParams = new URLSearchParams(search);

  const token = queryParams.get('token');

  const decodedToken = jwt(token);

  const auth = useAuth();

  const [
    accountCreated,
    setAccountCreated,
  ] = useState(false);

  const [
    firstName,
    setFirstName,
  ] = useState('');

  const [
    lastName,
    setLastName,
  ] = useState('');

  const [
    email,
    setEmail,
  ] = useState(decodedToken.username);

  const [
    passwd,
    setPasswd,
  ] = useState('');

  const [
    confirmPasswd,
    setConfirmPasswd,
  ] = useState('');

  const [
    phone,
    setPhone,
  ] = useState('');

  const [
    errorMessage,
    setErrorMessage,
  ] = useState('');

  const { snackBarShow, setSnackBarShow, snackBarMessage, setSnackBarMessage } = useContext(SnackbarContext);

  const [
    submittedDescription,
    setSubmittedDescription,
  ] = useState('');
  const [
    submittedShow,
    setSubmittedShow,
  ] = useState(false);
  const [
    submittedMessage,
    setSubmittedMessage,
  ] = useState('');

  const [
    loadingMessage,
    setLoadingMessage,
  ] = useState('');

  const [
    isLoading,
    setIsLoading,
  ] = useState(false);

  const navigate = useNavigate();

  function firstNameChangedHandler(e) {
    setFirstName(e.target.value);
  }

  function lastNameChangedHandler(e) {
    setLastName(e.target.value);
  }

  function passwdChangedHandler(e) {
    setPasswd(e.target.value);
  }

  function confirmPasswdChangedHandler(e) {
    setConfirmPasswd(e.target.value);
  }

  // function companyNameChangedHandler(e){
  //     setCompanyName(e.target.value)
  // }

  // function adminEmailChangedHandler(e){
  //     setAdminEmail(e.target.value)
  // }

  // function ABNchangedHandler(e){
  //     setABN(e.target.value)
  // }

  // function TANchangedHandler(e){
  //     setTAN(e.target.value)
  // }

  function phoneChangedHandler(e) {
    setPhone(e.target.value);
  }

  // function addressChangedHandler(e){
  //     setAddress(e.target.value)
  // }

  function isValidFirstName(firstName) {
    if (!firstName) {
      setSnackBarMessage('First name cannot be empty');
      setErrorMessage('Missing First Name');
      setSnackBarShow(true);
      return false;
    } else {
      return true;
    }
  }

  function isValidLastName(lastName) {
    if (!lastName) {
      setSnackBarMessage('Last name cannot be empty');
      setErrorMessage('Missing Last Name');
      setSnackBarShow(true);
      return false;
    } else {
      return true;
    }
  }

  function isValidConfirmPassword() {
    console.log(passwd);
    console.log(confirmPasswd);
    if (passwd !== confirmPasswd) {
      setSnackBarMessage('Password and Confirm Password do not match');
      setErrorMessage('Password Mismatch');
      setSnackBarShow(true);
      return false;
    } else {
      return true;
    }
  }

  function isValidEmail(email) {
    if (!email) {
      setSnackBarMessage('Email cannot be empty');
      setErrorMessage('Missing Mmail');
      setSnackBarShow(true);
      return false;
    }

    const result = validator.isEmail(email + '');
    if (result === true) {
      return true;
    } else {
      setSnackBarMessage('Please enter a valid work email');
      setErrorMessage('Invalid Email');
      setSnackBarShow(true);
      return false;
    }
  }

  function isValidPassword(password) {
    let passwordSchema = new passwordValidator();
    passwordSchema
      .is().min(8) // Minimum length 8
      .is().max(100) // Maximum length 100
      .has().uppercase() // Must have uppercase letters
      .has().lowercase() // Must have lowercase letter
      .has().digits(1) // Must have 1 digit
      .has().not().spaces() // Must not have any space
      .is().not().oneOf([
        '123456',
        'Passw0rd',
        'Password123',
      ]) // Password blacklist
      .has(/[!@#$%^&*]/g, 'The string must have at least 1 special character: !@#$%^&*'); // Must have at least 1 special character !@#$%^&*

    if (!password) {
      setSnackBarMessage('Password cannot be empty');
      setErrorMessage('Missing Password');
      setSnackBarShow(true);
      return false;
    }

    const result = passwordSchema.validate(password, { details: true });
    if (result.length === 0) {
      return true;
    } else {
      setSnackBarMessage(result[0].message);
      setErrorMessage('Invalid Password');
      setSnackBarShow(true);
      return false;
    }
  }

  function isValidPhone(phone) {
    if (!phone) {
      setSnackBarMessage(`Phone Number cannot be empty!`);
      setErrorMessage('Missing Phone Number');
      setSnackBarShow(true);
      return false;
    }

    const result = validator.isMobilePhone(phone);
    if (result) {
      return true;
    } else {
      setSnackBarMessage('Please enter a valid phone number!');
      setErrorMessage('Invalid Phone Number');
      setSnackBarShow(true);
      return false;
    }
  }

  // function isValidAddress (address) {
  //     if(!address) {
  //         setSnackBarMessage('Please enter an address')
  //         setErrorMessage('Invalid phone address')
  //         setSnackBarShow(true)
  //         return false
  //     }
  //     console.log(`Valid address: ${address}`)
  //     return true
  // }

  function handleSubmit() {
    if (!isValidFirstName(firstName)) {
      return false;
    }

    if (!isValidLastName(lastName)) {
      return false;
    }

    if (!isValidEmail(email)) {
      return false;
    }

    if (!isValidPassword(passwd)) {
      return false;
    }

    if (!isValidConfirmPassword()) {
      return false;
    }

    let postData = {
      firstName: firstName,
      lastName: lastName,
      email: decodedToken.username,
      password: passwd,
    };

    setIsLoading(true);
    setLoadingMessage('Creating you account ...');

    fetch(`${window.origin}/api/users/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(postData),
    }).then((resp) => {
      if (resp.status != 200) {
        setSnackBarMessage('Unknown error occured. Please try again later');
        setSnackBarShow(true);
        setIsLoading(false);
        throw new Error('Failed creating client');
      }
      return resp.json();
    }).then((data) => {
      console.log(data);

      setLoadingMessage('Acepting invite ...');
      fetch(`${window.origin}/api/users/invite/accept`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      }).then((resp) => {
        if (resp.status === 200) {
          setIsLoading(false);
          navigate('/invite/accepted');
        }
      });
    }).catch((e) => {
      console.log(e);
    });
  }

  function backToLogin() {
    if (!auth.isAuthenticated) {
      auth.signinRedirect();
    } else {
      console.log(auth.user?.access_token);
    }
  }

  return (
    <>

      <div style={{ display: 'flex', flexDirection: 'column', width: '100vw', height: '100vh' }}>

        <div style={{ display: 'flex', flexDirection: 'row', padding: '5vh 15vw', alignItems: 'center', height: '100vh' }}>

          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', margin: '1vw 7vw 5vw 7vw', color: 'rgb(0, 15, 30, 0.9)', backgroundColor: 'rgb(254, 254, 255, 0.8)', padding: '2vw 4vw', textAlign: 'center', borderRadius: '1.5vw' }}>
            <div style={{}}>
              <header style={{ marginBottom: '3vw' }}>
                <PersonAddAltOutlinedIcon style={{ color: '#1c6c6c', marginBottom: '1.5vw', fontSize: '3vw' }} />

                <h1 style={{ fontSize: '1.5vw', marginBottom: '1vw' }}>Tell us about your Organization</h1>
                <p style={{ fontSize: '0.85vw', margin: 0 }}>Please fill in the details below to register your organization with us</p>
              </header>

              <div style={{ marginLeft: '6vw', marginRight: '6vw', marginBottom: '1vw' }}>

                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <Form.Control
                    type="text"
                    value={firstName}
                    placeholder="First Name"
                    onChange={firstNameChangedHandler}
                    style={{
                      flex: 1,
                      borderRadius: '0.5vw',
                      backgroundColor: 'rgb(255, 255, 255, 0.3)',
                      fontSize: '0.85vw',
                      color: 'rgb(0, 0, 0, 0.8)',
                      border: 'none',
                      padding: '0.25vw 1vw',
                      margin: '1vw auto',
                      height: '3vw',
                      marginRight: '1vw',
                    }}
                  />
                  <Form.Control
                    type="text"
                    value={lastName}
                    placeholder="Last Name"
                    onChange={lastNameChangedHandler}
                    style={{
                      flex: 1,
                      borderRadius: '0.5vw',
                      backgroundColor: 'rgb(255, 255, 255, 0.3)',
                      fontSize: '0.85vw',
                      color: 'rgb(0, 0, 0, 0.8)',
                      border: 'none',
                      padding: '0.25vw 1vw',
                      margin: '1vw auto',
                      height: '3vw',
                    }}
                  />

                </div>

                <Form.Control
                  disabled
                  type="text"
                  value={decodedToken.username}

                  placeholder="Email"
                  style={{
                    borderRadius: '0.5vw',
                    backgroundColor: 'rgb(255, 255, 255, 0.3)',
                    fontSize: '0.85vw',
                    color: 'rgb(0, 0, 0, 0.8)',
                    border: 'none',
                    padding: '0.25vw 1vw',
                    margin: '0.5vw auto',
                    height: '3vw',
                  }}
                />

                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <Form.Control
                    type="password"
                    value={passwd}
                    placeholder="Password"
                    onChange={passwdChangedHandler}
                    style={{
                      flex: 1,
                      borderRadius: '0.5vw',
                      backgroundColor: 'rgb(255, 255, 255, 0.3)',
                      fontSize: '0.85vw',
                      color: 'rgb(0, 0, 0, 0.8)',
                      border: 'none',
                      padding: '0.25vw 1vw',
                      margin: '1vw auto',
                      height: '3vw',
                      marginRight: '1vw',
                    }}
                  />
                  <Form.Control
                    type="password"
                    value={confirmPasswd}
                    placeholder="Confirm Password"
                    onChange={confirmPasswdChangedHandler}
                    style={{
                      flex: 1,
                      borderRadius: '0.5vw',
                      backgroundColor: 'rgb(255, 255, 255, 0.3)',
                      fontSize: '0.85vw',
                      color: 'rgb(0, 0, 0, 0.8)',
                      border: 'none',
                      padding: '0.25vw 1vw',
                      margin: '1vw auto',
                      height: '3vw',
                    }}
                  />

                </div>

              </div>

              <Button
                onClick={handleSubmit}
                variant="outlined"
                style={{
                  borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '1vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
                  width: '20vw', marginTop: '2vw' }}
              >
                Continue
              </Button>

            </div>
          </div>

        </div>

        <Backdrop
          sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
          open={isLoading}
          onClick={() => { setIsLoading(false); }}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

      </div>

    </>
  );
}
